import type { Object3D, Vector3 } from "three";

import { IBoundingBoxResult } from "../helpers/computeBoundingBoxHelper";
import type { ILashingBridgeInfo } from "open-vessel-definition";

export class Module3D {
  private _deckVisible = true;
  private _objectsDictionary: Record<string, Object3D> = {};

  public holder3DInstance: Object3D;
  public worldPosition?: {
    pos: Vector3;
    bbox: IBoundingBoxResult | undefined;
  };

  public readonly name: string;
  public readonly inTail: 0 | 1;
  public readonly bsPosition: number;

  private _lashingBridges: ILashingBridgeInfo | undefined = undefined;

  /** @deprecated Never set by the builder. Lashing bridges are drawn with `createLashingBridgesGroup` */
  get lashingBridges() {
    return this._lashingBridges;
  }

  /** @deprecated Never set by the builder. Lashing bridges are drawn with `createLashingBridgesGroup` */
  set lashingBridges(v: typeof this._lashingBridges) {
    this._lashingBridges = v;
  }

  constructor(
    name: string,
    holder3DInstance: Object3D,
    bsPosition: number,
    inTail: 0 | 1 = 0,
  ) {
    this.name = name;
    this.holder3DInstance = holder3DInstance;
    this.bsPosition = bsPosition;
    this.inTail = inTail;

    this.createObjectsDictionary();
  }

  get deckVisible(): boolean {
    return this._deckVisible;
  }

  set deckVisible(v: boolean) {
    this._deckVisible = !!v;
  }

  get3D(name: string): Object3D | undefined {
    return this._objectsDictionary[name];
  }

  private createObjectsDictionary() {
    this.holder3DInstance.traverse((node) => {
      if (node.name) {
        this._objectsDictionary[node.name] = node;
      }
    });
  }
}
